import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import './HomeNavigation.css'
import HomeHeader from './HomeHeader'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import pbhl from '../../components/images/pbhl.png'
import rostersLogo from '../../../images/rosters.png'
import pbhlLogo from '../../../images/pbhl.png'
import pabhaLogo from '../../../images/pabha.png'
import infoLogo from '../../../images/info.png'

const HomeHomeNavigation = (props) => {
	const { pathname } = useLocation()

	console.log('inside HomeHomeNavigation for ' + pathname)

	//  could be /rosters
	//  could be /
	//  could be /info

	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='home-navigation__drawer-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='home-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				{pathname && pathname === '/' && (
					<div>
						<img src={pabhaLogo} className='headerLogo' />
					</div>
				)}
				{pathname && pathname === '/rosters' && (
					<div>
						<img src={rostersLogo} className='rosterLogo' />
					</div>
				)}
				{pathname && pathname === '/info' && (
					<div>
						<img src={infoLogo} className='headerLogo' />
					</div>
				)}
				<nav className='home-navigation__header-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</HomeHeader>
		</React.Fragment>
	)
}

export default HomeHomeNavigation
